// src/pages/AboutPage.jsx
import React from "react";
import Section from "../components/Section";
import { BRAND } from "../config/brandConfig";

function AboutPage() {
  return (
    <div>
      <Section
        eyebrow="About"
        title="A modern wealth partner with New England roots."
        kicker="This is where your friend's firm story lives—credentials, experience, and why Harborline exists."
      >
        <p style={{ fontSize: 14, color: "#475569", maxWidth: 680 }}>
          {BRAND.name} was built for New England families and business owners
          who wanted something different from the typical Wall Street
          experience—more substance, less noise. We combine institutional-grade
          investment process with practical, plain-language planning.
        </p>
        <p style={{ fontSize: 14, color: "#475569", maxWidth: 680 }}>
          The firm partners with clients through liquidity events, business
          transitions, and multi-generational planning—always as a fiduciary,
          always with a long-term view. Over time, the goal is simple: help you
          make a series of calm, well-governed decisions that compound in your
          favor.
        </p>
        <p style={{ fontSize: 13, color: "#64748b", maxWidth: 680 }}>
          (Your dev can later swap this copy for the real bio, credentials like
          CFP® / CFA®, and any required regulatory language.)
        </p>
      </Section>
    </div>
  );
}

export default AboutPage;
